<template>
    <label class="search" :data-search-state="searchState">
        <input type="text"
               class="search__input"
               :placeholder="$t('General.search')"
               v-bind="$attrs"
               v-bind:value="value"
               v-on:input="$emit('input', $event.target.value)"
        >
        <span :class="['search__input-icon icon-search', { 'isClosed': searchState === 'close' }]"></span>
        <span class="icon-clear" @click="clearSearch"></span>
        <span :class="toggleIconClass" v-on:click.prevent="toggleSearch"></span>
    </label>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'search-mobile',
        props: {
            value: String
        },
        data () {
            return {
                state: 'close'
            }
        },
        computed: {
            ...mapGetters({
                isSearchMobileCollapsed: 'getIsSearchMobileCollapsed',
                isSidebarCollapsed: 'getIsSidebarCollapsed'

            }),
            toggleIconClass () {
                return this.searchState === 'open' ? 'icon-cancel' : 'icon-search'
            },
            searchState () {
                return this.isSearchMobileCollapsed ? 'close' : 'open'
            }
        },
        methods: {
            openSearchInput () {
                this.state = 'open'
                this.$emit('toggle-search', this.state)
            },
            toggleSearch () {
                this.$store.dispatch('toggleSearchMobile')
                if (!this.isSidebarCollapsed) {
                    this.$store.dispatch('toggleSidebar')
                }
            },
            clearSearch () {
                this.$emit('clearSearch')
            }
        }
    }
</script>

<style lang="scss" scoped>
.search {
    position: relative;
    height: 65px;

    &__input {
        font-size: 1.6rem;
        padding: 0 10px 0 65px;
        height: 48px;
        width: 100vw;
        position: absolute;
        left: auto;
        right: -20px;
        z-index: -1;
        top: 65px;
        transition: top 0.26s ease;
        border-bottom: 1px solid $blaze_orange;
        border-top: 1px solid $blaze_orange;
        border-right: none;
        border-left: none;

        &:focus {
            outline: none;
        }
    }

    &__input::placeholder {
        color: $tuatara;
        opacity: 1;
    }

    .icon-search,
    .icon-cancel {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 2.5rem;
        z-index: 2;
        color: $tuatara;
    }

    .icon-clear {
        position: absolute;
        right: 0;
        top: 84px;
        transform: translateY(-50%);
        font-size: 1.4rem;
        transition: top 0.26s ease;
        z-index: -1;
        color: $blaze_orange;
    }

    &__input-icon.icon-search {

        &.isClosed {
            top: 0;
            background: transparent;
        }

        position: fixed;
        left: 24px;
        top: 89px;
        transform: translateY(-50%);
        font-size: 1.9rem;
        transition: top 0.26s ease;
        z-index: -1;
        color: $lavender;    
    }

    &[data-search-state="close"] {
        .search__input {
            top: 0;
            background: transparent;
        }

        .icon-clear {
            top: 4px;
        }
    }
}
</style>
